import React from "react";
import { MDBCol, MDBContainer, MDBRow, MDBFooter, MDBIcon } from "mdbreact";
import SocialLink from "../../Components/ComponentFragments/SocialLink";

const Footer = () => {
    return (
        <div className="navBackround pt-2">

            <div className="footer-copyright text-center py-3">
                <MDBContainer>
                    <MDBRow>
                        <MDBCol md="12">
                            <div><a target="_blank" href="http://amp.tuppafrica.co.za/termsandconditions.html"><MDBIcon far icon="file-alt" />&nbsp;Terms and Conditions </a></div>
                            <div>
                            &copy; {new Date().getFullYear()} Copyright:{" "}
                                <a target="_blank" href="https://www.tuppafrica.co.za"> Tupperware </a>&nbsp;V{global.appVersion}
                            </div>
                            
                        </MDBCol>
                    </MDBRow>
                    <SocialLink />
                </MDBContainer>
            </div>


        </div>
    );
}

export default Footer;